import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemText,
  TableContent,
  TableContentItemCaptions,
  TableContentItemButton,
  TableContentItemLabel,
} from '../../../../../../components/TableContent';
import { mapCaptions } from '../../../../utils';

import { ResponsiveItemProps } from '.';

export const MobileItem: React.FC<ResponsiveItemProps> = ({ item, handleSelect }) => {
  return (
    <TableContent direction="row">
      <VStack space={Spacing['inline.xxxs']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Text
            color="neutral.darkest"
            variant="semibold"
            fontSize={Typography['fontsize.md']}
            noOfLines={1}>
            {item.name}
          </Text>
          <HStack space={Spacing['inline.nano']}>
            <TableContentItemCaptions icons={mapCaptions(item)} />
            <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
          </HStack>
        </HStack>
        <HStack justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>CPF/CNPJ</TableContentItemLabel>
            <TableContentItemText>{item.cpfCnpjFormatted}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Cadastro</TableContentItemLabel>
            <TableContentItemText>{item.registrationStatusName}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Conta</TableContentItemLabel>
            <TableContentItemText>{item.accountNumber}</TableContentItemText>
          </VStack>
        </HStack>
        <HStack justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Saldo disponível</TableContentItemLabel>
            <TableContentItemText>{item.availableBalanceFormatted}</TableContentItemText>
          </VStack>
          <TableContentItemButton onPress={handleSelect} />
        </HStack>
      </VStack>
    </TableContent>
  );
};
